import { DeclaredOrganization, ORGAS_TOKEN } from "@ubisolutions/core";
import { LogisticalCenterSelectorGraphql } from "@shared/business/queries/dropdown-selectors.graphql";

export const organizationsProvider = {
    provide: ORGAS_TOKEN,
    useValue: [
        {
            typename: "LogisticalCenter",
            searchAttribute: "name",
            query: LogisticalCenterSelectorGraphql,
        },
    ] satisfies DeclaredOrganization[],
};
